export const requestBody: any = {
  AppId: 1002,
  CustFavorite: false,
  ResultType: 1,
  SearchOptions: null,
  PageSize: 3,
};
